import { CheckCircle } from 'react-feather';

type ModalsTypes = {
  header: string;
  message: string;
  theme: 'success' | 'danger';
  buttonText: string;
  icon?: JSX.Element | string;
};

type ModalProps = {
  [key: string]: ModalsTypes;
};

export const modals: ModalProps = {
  'plaid.success': {
    header: 'Success',
    message: 'Your account has been successfully verified with plaid',
    theme: 'success',
    buttonText: 'Continue',
  },
  'plaid.error': {
    header: 'Sorry',
    message: 'We had trouble getting your bank information.',
    theme: 'danger',
    buttonText: 'Try again',
  },
  'provide.credentials': {
    header: 'Attention',
    message: 'Please, provide your bank account credentials.',
    theme: 'success',
    buttonText: 'Ok',
  },
  'plaid.manual.verification': {
    header: 'Success',
    icon: <CheckCircle color="#5CB85C" />,
    message:
      'We have received your credentials, within 3 days we will send you an email if everything went well.',
    theme: 'success',
    buttonText: 'Continue',
  },
};
